import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export const useNavigation = () => {
  const navigate = useNavigate();

  const navigateToPage = useCallback(
    (path: string, replace?: boolean, state?: any) => {
      navigate(path, { replace, state });
    },
    [],
  );

  const navigateToNewTab = useCallback((path: string) => {
    window.open("#" + path, "_blank");
  }, []);

  return {
    navigateToPage,
    navigateToNewTab,
  };
};
